import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState } from 'react';
import Shop from './Shop';
import Order from './Order';
import state from './catalog/state';
import { admin_tg } from './components/constants'
import SEOHeader from './SEOHeader';



function App() {

  const [order, updateOrdr] = useState(state);

  window.Telegram.WebApp.onEvent('mainButtonClicked', function(e) {
    window.Telegram.WebApp.MainButton.showProgress()
    window.location.href='https://t.me/' + admin_tg
    window.Telegram.WebApp.MainButton.hideProgress()
    // window.Telegram.WebApp.sendData(order)
    // let req = new XMLHttpRequest();
  
    // req.onreadystatechange = () => {
    //   console.log(order)
       //window.Telegram.WebApp.sendData(order)
      //  if (!isTelegram) {
      //     
      //  } else {
      //     window.Telegram.WebApp.sendData(order)
      //  }
    // };
  })
  
  const addProduct = (p) => {
    order[p].count = order[p].count + 1
    updateOrdr(ordr=>[...ordr]) //little hack
    if (order.map(it => it > 0).length > 0 ) {
        window.Telegram.WebApp.MainButton.isVisible = true
        window.Telegram.WebApp.MainButton.text = '🛒 НАПИСАТИ МЕНЕДЖЕРУ' 
    }
  }
  const rmProduct = (p) => {
    order[p].count = 0
    updateOrdr(ordr=>[...ordr])
    if (order.map(it => it > 0).length > 0 ) {
        window.Telegram.WebApp.MainButton.isVisible = true
        window.Telegram.WebApp.MainButton.text = '🛒 НАПИСАТИ МЕНЕДЖЕРУ' 
    } else {
      window.Telegram.WebApp.MainButton.isVisible = false
    }
  }

  return (
    <div className="App">
      <SEOHeader title="HHC/THC Vapes" description="Найкращі hhc thc вейпи" keywords="hhc, thc, cbd"></SEOHeader>
      <Shop addProduct={addProduct} rmProduct={rmProduct} products={order} />
      <Order order={order.filter(i => i.count > 0)}/>
    </div>
  );
}

export default App;
